/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminMarketComparable
 */
export interface AdminMarketComparable {
    /**
     * 
     * @type {string}
     * @memberof AdminMarketComparable
     */
    condition?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminMarketComparable
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminMarketComparable
     */
    itemId: string;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketComparable
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketComparable
     */
    shipping: number;
    /**
     * ShippingEstimated: the shipping cost was unknown and our label cost was used.
     * @type {boolean}
     * @memberof AdminMarketComparable
     */
    shippingEstimated: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminMarketComparable
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketComparable
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof AdminMarketComparable
     */
    url: string;
}

export function AdminMarketComparableFromJSON(json: any): AdminMarketComparable {
    return AdminMarketComparableFromJSONTyped(json, false);
}

export function AdminMarketComparableFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketComparable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'condition': !exists(json, 'condition') ? undefined : json['condition'],
        'imageUrl': !exists(json, 'imageUrl') ? undefined : json['imageUrl'],
        'itemId': json['itemId'],
        'price': json['price'],
        'shipping': json['shipping'],
        'shippingEstimated': json['shippingEstimated'],
        'title': json['title'],
        'total': json['total'],
        'url': json['url'],
    };
}

export function AdminMarketComparableToJSON(value?: AdminMarketComparable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'condition': value.condition,
        'imageUrl': value.imageUrl,
        'itemId': value.itemId,
        'price': value.price,
        'shipping': value.shipping,
        'shippingEstimated': value.shippingEstimated,
        'title': value.title,
        'total': value.total,
        'url': value.url,
    };
}

